module.exports = {"id":"139968","name":"Vincent Enyeama","rating":"78","photo":"./data/images/photos/4/139968.png","club":{"name":"LOSC","logo":"./data/images/clubs/LOSC.png"},"positions":["G"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/VincentEnyeama0.json
// module id = 4274
// module chunks = 0